var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduleIcon = function SvgScheduleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "schedule-icon_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#schedule-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "schedule-icon_svg__b",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M15.5 15.5V.5H.5v15z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#024ca8",
    mask: "url(#schedule-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.875A7.875 7.875 0 0 0 8.5.141a.477.477 0 0 0-.5.484.53.53 0 0 0 .5.518A6.876 6.876 0 1 1 1.143 8.5.53.53 0 0 0 .625 8a.477.477 0 0 0-.484.5A7.875 7.875 0 0 0 8 15.875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.318 10.204 8.185 8.677V5.566A.58.58 0 0 0 7.593 5 .58.58 0 0 0 7 5.566V8.96c0 .178.088.346.237.452l2.37 1.697a.6.6 0 0 0 .355.113c.18 0 .359-.077.475-.227a.55.55 0 0 0-.119-.791M5.541 1.679l.067-.128a1 1 0 0 0-.067.128m-.627.132h-.002a.55.55 0 0 1-.507-.336.55.55 0 1 1 .728.296.6.6 0 0 1-.219.04m.29.147h.001m-2.29.044q-.032-.01-.063-.016.03.006.062.016m-.191 1.277a.55.55 0 0 1-.391-.164l-.001-.002-.004-.003a.55.55 0 1 1 .778.003l-.001.002a.55.55 0 0 1-.381.164m.003.201h-.004.002a.75.75 0 0 1 .002.001m-.54-.228-.051-.057zm-1.21.974h.002zm.285 1.237h-.004a.6.6 0 0 1-.21-.04.55.55 0 1 1 .725-.296.55.55 0 0 1-.511.336"
  })))));
};
export default SvgScheduleIcon;